export function failedMessages(substate, key = "failed") {
  let failed = substate.get(key);
  if (!failed) {
    return { messages: [] };
  }
  failed = failed.message;
  failed.messages = [];
  Object.keys(failed).forEach(objKey => {
    if (objKey === "messages") {
      return;
    }
    failed.messages.push(failed[objKey]);
  });
  return failed;
}
